import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTabsModule } from '@angular/material/tabs';
import { HotToastModule } from '@ngneat/hot-toast';
import { SharedModule } from 'src/app/shared/shared.module';
import { StripePurchasePopupComponent } from './stripe-purchase-popup/stripe-purchase-popup.component';
import { StripePurchaseService } from './stripe-purchase.service';
import {MatDialogModule} from "@angular/material/dialog";
import { StripeConfirmationPopupComponent } from './stripe-purchase-popup/stripe-confirmation-popup/stripe-confirmation-popup.component';

@NgModule({
    imports: [
        ReactiveFormsModule,
        MatFormFieldModule,
        CommonModule,
        SharedModule,
        MatButtonModule,
        MatDividerModule,
        MatTabsModule,
        MatListModule,
        MatIconModule,
        FormsModule,
        MatAutocompleteModule,
        MatFormFieldModule,
        MatInputModule,
        ReactiveFormsModule,
        MatChipsModule,
        MatProgressSpinnerModule,
        MatMenuModule,
        HotToastModule.forRoot(),
        MatDialogModule,
    ],
  declarations: [
    StripePurchasePopupComponent,
    StripeConfirmationPopupComponent
  ],
  providers: [
    StripePurchaseService
  ]
})
export class StripePurchaseModule {}
